module.exports = __webpack_public_path__ + "static/media/036.be481ab5.png";